const main = () => {
    document.querySelectorAll('.c-others-slider-dots').forEach((container) => {
        container.querySelectorAll('.c-others-slider-dots__dot').forEach((dot) => {
            dot.addEventListener('click', () => {
                container.querySelectorAll('.c-others-slider-dots__dot').forEach((d) => {
                    delete d.dataset.active;
                });
                dot.dataset.active = '';
                container.dataset.current = dot.dataset.index;

                container.dispatchEvent(new CustomEvent('slider-dots:change', {
                    detail: { index: Number(dot.dataset.index) },
                    bubbles: true,
                }));
            });
        });
    });
};

export default main;
